import { MentorIntelligence } from '@/components/mentor/MentorIntelligence';

export default function MentorIntelligencePage() {
  return (
    <div className="container mx-auto py-8 px-4 max-w-7xl">
      <MentorIntelligence />
    </div>
  );
}
